module.exports = __webpack_public_path__ + "static/media/people.603c3e9b.svg";